import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import RoutesComponent from './routes/RoutesComponent';
import useAuth from './hooks/useAuth';
import useUserStatus from './hooks/useUserStatus';
import { ThemeProvider } from './context/ThemeContext';

import DevMessagesModal from './components/DevMessagesModal';

import './App.css';
import './scroller.css';

import { AuthProvider } from './context/AuthContext';
import { checkAppVersion } from './utils/getVersion';

const App = () => {
  const { user, loading } = useAuth();
  useUserStatus(user);

  const [appReady, setAppReady] = useState(false);

  useEffect(() => {
    async function verifyVersion() {
      const { isUpdated, news, latestVersion } = await checkAppVersion();

      if (!isUpdated) {
        alert(`Жаңа нұсқа қолжетімді: ${latestVersion}\n\n${news}`);
        window.location.reload();
      } else {
        setAppReady(true);
      }
    }

    verifyVersion();
  }, []);

  if (loading || !appReady) {
    return null;
  }

  return (
    <AuthProvider>
      <ThemeProvider>
        <Router>
          <RoutesComponent user={user} />
          {user && <DevMessagesModal />}
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
};

export default App;